import React, { Component } from 'react'
import cx from 'classnames'
import UISelect from 'components/shared/UISelect'
import Tag from 'shared-web/src/components/Tag'
import { normalizeColor } from 'utils/TagAppearanceHelper'
import * as style from './style'

import { makeDefaultFailedContainer } from 'components/container'

class TagSelect extends Component {
  static defaultProps = {
    multi: true,
  }

  renderTag = tag => <Tag tag={normalizeColor(tag)}/>

  render() {
    const { multi, selected, tags, onChange, className, ...props } = this.props
    const filteredTags = _.filter(tags, tag => tag.status !== 'ARCHIVED')
    return (
      <UISelect
        className={cx(className, style.TagSelect)}
        placeholder="All Tags"
        multi={multi}
        searchable={false}
        value={
          multi
            ? selected.map(id => filteredTags.find(tag => tag.id === id))
            : filteredTags.find(tag => tag.id === selected)
        }
        menuBuffer={10}
        options={filteredTags}
        onChange={onChange}
        valueKey="name"
        labelKey="id"
        optionRenderer={this.renderTag}
        valueRenderer={this.renderTag}
        clearable={!multi}
        {...props}
      />
    )
  }
}

export default makeDefaultFailedContainer(TagSelect, {
  listenTo: ['stores.TagStore'],
  fetch: {
    tags() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList()
    },
  },
})



// WEBPACK FOOTER //
// ./src/scripts/components/shared/TagSelect/index.js